import React from "react";
import { Notifications } from "expo";

import registerForPushNotificationsAsync from "./register";

export default class NotificationContainer extends React.Component {
  state = {
    notification: {}
  };

  componentDidMount() {
    registerForPushNotificationsAsync();
    this._notificationSubscription = Notifications.addListener(
      this._handleNotification
    );
  }

  _handleNotification = notification => {
    const { gameId, user } = notification.data;

    const { navigate } = this.props.navigation;

    global.RunningGame = {
      name: user.name,
      game: { id: gameId }
    };

    navigate("CurrentGame");
    this.setState({ notification: notification });
  };

  render() {
    return null;
  }
}
